document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.urjc-landing-iex-container');
    
    containers.forEach(function(container) {
      const tabs = container.querySelectorAll('.tab-navigation button');
      const contents = container.querySelectorAll('.tab-content');
      
      const hideAllContents = () => {
        contents.forEach(content => content.style.display = 'none');
        tabs.forEach(tab => tab.classList.remove('active'));
      };
      
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          hideAllContents();
          this.classList.add('active');
          const target = this.getAttribute('data-tab');
          const activeContent = container.querySelector(`.tab-content[data-tab-content="${target}"]`);
          if (activeContent) {
            activeContent.style.display = 'block'; 
          }
        });
      });
      
      // Inicialización: muestra la pestaña de exportación por defecto
      hideAllContents();
      if (tabs.length) {
        tabs[0].classList.add('active');
        const target = tabs[0].getAttribute('data-tab');
        const activeContent = container.querySelector(`.tab-content[data-tab-content="${target}"]`);
        if (activeContent) {
          activeContent.style.display = 'block';
        }
      }
    });
  });
  